import styled from "styled-components";

export const StockDifference = styled.div`
    border-radius: ${props => props.border ? '17px' : '0px'};
    background: ${props => props.background ? props.background : "none"};
    padding: ${props => props.background ? '0 8px 0 10px' : "0 7px 0 5px"};
`
